import { Button, Grid, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { convertDate } from "../../utils/utils";
import { exportToExcel } from "../../utils/xlsxHelper";
import SendingGiftsTable from "./components/SendingGiftsTable";
import { getAllPrizeHistoryForExcel } from "../../redux/slices/giftsProductsSlice";

const AdminSendingGifts = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch()
  const [isExportable, setIsExportable] = useState(false);
  const allGiftsForSending = useSelector(
    (state) => state.giftsProducts.allPrizeHistory
  );
  const allUserPrizesForExcel = useSelector(
    (state) => state.giftsProducts.allUserPrizesForExcel
  );
  useEffect(()=>{
    dispatch(getAllPrizeHistoryForExcel())
  },[dispatch])
  const prepareDateForExport = (data) => {
    const preparedData = allUserPrizesForExcel.map((prizeInfo) => {
      return {
        id: prizeInfo.id,
        username: prizeInfo.attributes.shippingInfo[0].username,
        datum_porucivanja: convertDate(prizeInfo.attributes.createdAt),
        poklon: prizeInfo.attributes.prize.name,
        ime: prizeInfo.attributes.shippingInfo[0].name,
        prezime: prizeInfo.attributes.shippingInfo[0].surname,
        licna_karta: prizeInfo.attributes.shippingInfo[0].idNum,
        email: prizeInfo.attributes.shippingInfo[0].email,
        telefon: prizeInfo.attributes.shippingInfo[0].phoneNumber,
        adresa: prizeInfo.attributes.shippingInfo[0].address,
        grad: prizeInfo.attributes.shippingInfo[0].city,
      };
    });
    return preparedData;
  };
  const onExportToExcel = () => {
    const data = prepareDateForExport();
    exportToExcel(data);
  };
  useEffect(() => {
    setIsExportable(allGiftsForSending?.length > 0);
  }, [allGiftsForSending]);
  return (
    <Box padding="24px">
      <Stack direction="column">
        <Grid display="flex" justifyContent="space-between" padding="24px 0">
          <Typography variant="h5">{t("adminPrizeHistory.title")}</Typography>
          <Button
            disabled={!isExportable}
            variant="contained"
            size="small"
            onClick={onExportToExcel}
          >
            {t("adminPrizeHistory.exportExcel")}
          </Button>
        </Grid>
        <SendingGiftsTable />
      </Stack>
    </Box>
  );
};

export default AdminSendingGifts;
